<template>
  <ul class="nav nav-pills">
    <li>
      <router-link tag="a" class="btn btn-dark" :to="{ name: 'managers.talent.index', params: { managerId: user.id } }" exact>
        Talent ({{ user.management_talent_count }})
      </router-link>
    </li>
    <li>
      <router-link tag="a" class="btn btn-dark" :to="{ name: 'managers.requests.index', params: { managerId: user.id } }" exact>
        Requests ({{ user.management_request_count }})
      </router-link>
    </li>
    <li>
      <router-link tag="a" class="btn btn-dark" :to="{ name: 'managers.bookings.index', params: { managerId: user.id } }" exact>
        Bookings ({{ user.management_booking_count }})
      </router-link>
    </li>
  </ul>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: mapState('user', ['user'])
}
</script>
